/** Para onde leva cada assistente (resposta da ajuda, primeiros passos, galeria de modelos). */
export function wizardRoute(id: string, catalogId?: string): string {
  switch (id) {
    case 'invite-people':
      return '/users?invite=1';
    case 'profile':
      return '/users/profiles/new';
    case 'api-account':
      return '/integrations/api?new=1';
    case 'auth-oidc':
      return '/users/auth?configure=oidc';
    case 'auth-saml':
      return '/users/auth?configure=saml';
    case 'agent-create':
      return '/agents/new';
    case 'collector-create':
      return '/agents/collector';
    case 'subnet-create':
      return '/tags';
    case 'integration-connect':
      return catalogId ? `/integrations/connect/${encodeURIComponent(catalogId)}` : '/integrations?category=identity';
    default:
      return '/';
  }
}

/** Telas do protótipo (T-xx) → rotas da console, para cartões e resultados de busca. */
export function screenRoute(screen: string | undefined, filter?: Record<string, string> | null): string {
  const f = filter ?? {};
  switch (screen) {
    case 't06':
      if (f.tab) return `/users/${f.tab}`;
      return f.status ? `/users?status=${encodeURIComponent(f.status)}` : '/users';
    case 't47':
      return f.tab ? `/integrations/${f.tab}` : '/integrations';
    case 't08':
    case 't07':
      return '/audit';
    case 't43':
      return '/help';
    case 't10': {
      const p = new URLSearchParams();
      for (const k of ['kind', 'agent', 'os', 'tag', 'site', 'vlan', 'group', 'changedSince']) if (f[k]) p.set(k, f[k]);
      const q = p.toString();
      return q ? `/assets?${q}` : '/assets';
    }
    case 't11':
      return f.id ? `/assets/${encodeURIComponent(f.id)}` : '/assets';
    case 't12':
      return '/agents/new';
    case 't13':
      return '/agents';
    case 't14':
      return '/directory/connect';
    case 't15':
      return '/directory/machines';
    case 't16':
      return '/tags';
    case 't17':
      return '/alerts/rules';
    case 't03':
      return '/dashboards';
    case 't18':
      return '/alerts/rules/new';
    case 't19':
      return '/alerts';
    // integração com o Autonomous ligada: o número de alertas abertos do Início leva ao mural NOC
    case 'noc':
      return '/noc';
    case 'rightsizing':
      return '/rightsizing';
    case 'ot':
      return f.tab ? `/ot/${f.tab}` : '/ot';
    case 't22':
      return '/alerts/channels';
    case 't42':
      return '/itsm';
    case 't30':
      return '/vulnerabilities';
    case 't31':
      return '/software';
    default:
      return '/';
  }
}

/** Resultado da busca global (T-04): o tipo e a tela dizem para onde ele leva. */
export interface SearchHit {
  type?: string;
  id?: string;
  title?: string;
  subtitle?: string;
  screen?: string;
}

/** Para onde leva um resultado da busca global (a paleta abre isso; com o Autonomous, o que leva a tela dele sai). */
export function searchRoute(it: SearchHit): string {
  if (it.type === 'asset' && it.id) return `/assets/${encodeURIComponent(it.id)}`;
  if (it.type === 'person') return `/users?q=${encodeURIComponent(it.subtitle?.split(' ')[0] ?? it.title ?? '')}`;
  if (it.type === 'integration' && it.id) return `/integrations?q=${encodeURIComponent(it.title ?? '')}`;
  if (it.type === 'cve' && it.id) return `/vulnerabilities/cve/${encodeURIComponent(it.id)}`;
  if (it.type === 'rule' && it.id) return `/alerts/rules/${encodeURIComponent(it.id)}`;
  if (it.type === 'contract' && it.id) return `/contracts/${encodeURIComponent(it.id)}`;
  return screenRoute(it.screen);
}
